import productLoction from '@/api/product-location'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  locations: [],
  products: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_LOCATIONS(state, data) {
    state.locations = data
  },
  SET_PRODUCTS(state, data) {
    state.products = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return productLoction.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return productLoction.store(data)
  },
  destroy(context, id) {
    return productLoction.destroy(id)
  },

  async dataBeforeCreate(context) {
    if (!context.state.locations.length > 0) {
      let response = await productLoction.warehouse()
      context.commit('SET_LOCATIONS', response)
    }
  },
  async product(context, location_id) {
    context.commit('SET_PRODUCTS', [])
    let response = await productLoction.product(location_id)
    context.commit('SET_PRODUCTS', response)
  }
}
